var context = {
    lifecycleCallback: {},
    registerLifecycle: function (lifecycle, callback) {
        var _this = this;
        this.lifecycleCallback[lifecycle] = this.lifecycleCallback[lifecycle] || [];
        this.lifecycleCallback[lifecycle].push(callback);
        return function () {
            _this.lifecycleCallback[lifecycle].splice(_this.lifecycleCallback[lifecycle].indexOf(callback), 1);
        };
    },
};
export default context;
